function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4318ff",
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.348 5.58254c-1.9571-2.28806-5.22079-2.90354-7.67294-.80837-2.45216 2.09518-2.79739 5.59823-.8717 8.07623 1.60108 2.0602 6.44654 6.4055 8.03464 7.8119.1776.1573.2665.236.3701.2669.0904.027.1894.027.2798 0 .1036-.0309.1925-.1096.3702-.2669 1.588-1.4064 6.4335-5.7517 8.0345-7.8119 1.9257-2.478 1.6227-6.00309-.8717-8.07623-2.4943-2.07313-5.7158-1.47969-7.6729.80837z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      stroke: "#4318ff",
      strokeWidth: 1.46833,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartactive);
export default __webpack_public_path__ + "static/media/heart.active.982be91f39542e41229ec0d178dd12f9.svg";
export { ForwardRef as ReactComponent };